export class CreatePaymentIntentPaypalRequest {
    
    public userId!:string;
    public auctionId!:number;
    public auctionDescription!:string;
    public scheduleSequenceNo!:number;
    public amount!:number;
    
    constructor(){
    }
}